import { SettingsMenuIcon } from '@/assets/icons/menu-icons/settings';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { IDescriptionSection } from './types';

export const DescriptionSection = ({ title, description }: IDescriptionSection) => {
  return (
    <Section>
      <SettingsMenuIcon width={29} height={30} fill={themeVar('font.weak')} />
      <SectionBody>
        <SectionTitle>{title}</SectionTitle>
        {description.map((item, index) => (
          <TextLine key={item + index}>{`${index + 1}. ${item}`}</TextLine>
        ))}
      </SectionBody>
    </Section>
  );
};

const Section = styled.div`
  width: 100%;
  display: flex;
  gap: 15px;
`;

const SectionTitle = styled.div`
  color: ${themeVar('font.base')};
  font-family: Blinker;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22.4px;
  padding: 3px 0;
  margin-bottom: 15px;
`;

const SectionBody = styled.div``;

const TextLine = styled.p`
  color: ${themeVar('font.base')};
  font-family: Blinker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
`;
